import { JourneyEngineConfigs, RouteConfig } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import {
	_root,
	requestContact,
	serviceError,
	subscriptionConclusion,
	subscriptionResumeAndAuthorization,
	subscriptionSelectAccount,
	subscriptionSelectPlan,
	subscriptionTermsAndConditionsBank,
	subscriptionTermsAndConditionsSoftware,
	integratedSolutionConclusion,
	integratedSolutionResumeAndAuthorization,
	integratedSolutionSelectAccount,
	integratedSolutionSelectSolution,
	integratedSolutionTermsAndConditionsBank,
	intro,
} from './prisms';
import { ROUTES } from '@navigation';

const journeyEngineConfigs: JourneyEngineConfigs<RouteConfig> = {
	navigators: [
		{
			exact: true,
			name: ROUTES.serviceError,
			path: ROUTES.serviceError,
			prism: serviceError.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionSelectPlan,
			path: ROUTES.subscriptionSelectPlan,
			prism: subscriptionSelectPlan.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionSelectAccount,
			path: ROUTES.subscriptionSelectAccount,
			prism: subscriptionSelectAccount.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionTermsAndConditionsSoftware,
			path: ROUTES.subscriptionTermsAndConditionsSoftware,
			prism: subscriptionTermsAndConditionsSoftware.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionTermsAndConditionsBank,
			path: ROUTES.subscriptionTermsAndConditionsBank,
			prism: subscriptionTermsAndConditionsBank.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionResumeAndAuthorization,
			path: ROUTES.subscriptionResumeAndAuthorization,
			prism: subscriptionResumeAndAuthorization.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.subscriptionConclusion,
			path: ROUTES.subscriptionConclusion,
			prism: subscriptionConclusion.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.requestContact,
			path: ROUTES.requestContact,
			prism: requestContact.prismName,
			subRoutes: [],
		},

		{
			exact: true,
			name: ROUTES.integratedSolutionSelectSolution,
			path: ROUTES.integratedSolutionSelectSolution,
			prism: integratedSolutionSelectSolution.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.integratedSolutionSelectAccount,
			path: ROUTES.integratedSolutionSelectAccount,
			prism: integratedSolutionSelectAccount.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.integratedSolutionTermsAndConditionsBank,
			path: ROUTES.integratedSolutionTermsAndConditionsBank,
			prism: integratedSolutionTermsAndConditionsBank.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.integratedSolutionResumeAndAuthorization,
			path: ROUTES.integratedSolutionResumeAndAuthorization,
			prism: integratedSolutionResumeAndAuthorization.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.integratedSolutionConclusion,
			path: ROUTES.integratedSolutionConclusion,
			prism: integratedSolutionConclusion.prismName,
			subRoutes: [],
		},
		{
			exact: true,
			name: ROUTES.intro,
			path: ROUTES.intro,
			prism: intro.prismName,
			subRoutes: [],
		},
		{
			default: true,
			exact: true,
			name: 'home',
			path: ROUTES.root,
			prism: _root.prismName,
			subRoutes: [],
		},
	],
};

export default journeyEngineConfigs;
